export const initialState = {
  profile: undefined
};
